import makeRequest from 'api/makeRequest';
import environment from 'environment';

const { SHOPIFY_BASE_URL } = environment.eCommerce;

export const fetchCustomerInfo = async (customerId, simplrAccountId, shopName) => {
  const url = `${SHOPIFY_BASE_URL}/customer/${customerId}`;
  const config = {
    method: 'get',
    params: {
      simplrAccountId,
      shopName,
    },
  };

  return await makeRequest(url, config);
};

export const patchCustomerNotes = async ({ simplrAccountId, customerId, shopName, note }) => {
  const url = `${SHOPIFY_BASE_URL}/customer/note`;
  const config = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      simplrAccountId,
      customerId: String(customerId),
      shopName,
      note,
    },
  };

  return await makeRequest(url, config);
};
